module.exports = __webpack_public_path__ + "img/1479014499.fd07681a.jpg";